import React from 'react';
import { motion } from 'framer-motion';
export function CreatorQuote() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-dark border-y border-white/5" data-id="element-69">
      <div className="max-w-xl mx-auto text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-71">
          <h3 className="text-sm font-bold text-brand-orange uppercase mb-5 tracking-widest" data-id="element-72">
            A proposito di Programmazione Pronta™
          </h3>

          <blockquote className="text-lg sm:text-xl font-medium text-brand-cream italic leading-relaxed mb-5" data-id="element-73">
            "Ho creato questo sistema per liberare i docenti di informatica dal
            peso soffocante della preparazione manuale. Più tempo per insegnare,
            meno tempo per pianificare."
          </blockquote>

          <div className="font-black text-gray-400 text-sm" data-id="element-74">
            — Programmazione Pronta™
          </div>
        </motion.div>
      </div>
    </section>;
}